module.exports = __webpack_public_path__ + "static/media/Inter-Black.980c7e87.ttf";